import Cuttr from "cuttr";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// Menu mobile
	const mobileMenu = document.querySelector("#_mobile_menu");
	const mobileMenuBtn = document.querySelector("#_mobile_menu_btn");
	if (!!mobileMenu && !!mobileMenuBtn) {
		mobileMenuBtn.addEventListener("click", () => {
			mobileMenuBtn.classList.toggle("open");
			mobileMenu.classList.toggle("open");
		});
	}

	if (document.querySelector("#_ext_plot")) {
		new Cuttr("#_ext_plot", {
			licenseKey: "4182D27D-7330450C-BA2FDF21-5D8BBEDB",
			truncate: "characters",
			length: 750,
			readMore: true,
			readMoreText: "Espandi",
			readLessText: "Chiudi",
			readMoreBtnPosition: "inside",
			readMoreBtnTag: "a",
			readMoreBtnSelectorClass: "more-link",
		});
	}
});
